import { render, staticRenderFns } from "./SocialOrganicPerformanceHighlights.vue?vue&type=template&id=12dafb40"
import script from "./SocialOrganicPerformanceHighlights.vue?vue&type=script&lang=js"
export * from "./SocialOrganicPerformanceHighlights.vue?vue&type=script&lang=js"
import style0 from "./SocialOrganicPerformanceHighlights.vue?vue&type=style&index=0&id=12dafb40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports